class HHVariantPicker extends HTMLElement {
  constructor() {
    super()
    this.mode = this.getAttribute('data-mode')
    this.addEventListener('change', (e) => this.onVariantChange(e))
  }

  connectedCallback() {
    this.mode = this.getAttribute('data-mode')
    if (!window.location.search.includes('variant')) return
    setTimeout(() => {
      this.onVariantChange()
    }, 1000)
  }

  onVariantChange(event) {
    this.updateOptions()
    this.updateMasterId()
    this.toggleAddButton(true, '', false)
    this.updatePickupAvailability()

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true)
      this.setUnavailable()
    } else {
      this.setActive()
      if (this.mode == 'main') {
        this.updateMedia()
        this.updateURL()
        this.renderProductInfo()
        if (event?.isTrusted) {
          this.updateStickySizeInfo()
        }
      } else {
        // For non-main modes (e.g., "card"), update button state based on availability
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.getNotified
        )
      }
      this.updateVariantInput()
    }
  }

  setActive() {
    document.querySelectorAll(
      `.js-product-select-option[data-section="${this.dataset.section}"]`
    ).forEach(element => {
      element.closest('.js-product-form')?.classList?.remove('disable-notify')
      element.remove()
    })
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'))
    if (fieldsets && fieldsets.length) {
      this.options = fieldsets.map((fieldset) => {
        return Array.from(fieldset.querySelectorAll('input')).find(
          (radio) => radio.checked
        )?.value
      })
    } else {
      this.options = Array.from(
        this.querySelectorAll('select'),
        (select) => select.value
      )
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        ?.map((option, index) => {
          return this.options[index] === option
        })
        .includes(false)
    })
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    )
    if (!newMedia) return
    newMedia.parentElement.dispatchEvent(
      new CustomEvent('hh-slider:scroll-to', {
        detail: {
          index: Number(newMedia.dataset.index),
        },
      })
    )
  }

  updateURL() {
    if (!this.currentVariant) return
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    )
  }

  updateVariantInput() {
    const productForms = this.closest('.js-product-form-wrapper')?.querySelectorAll(
      'form.installment, form[data-type="add-to-cart-form"]'
    )
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]')
      input.value = this.currentVariant.id
      input.dispatchEvent(new Event('change', { bubbles: true }))
    })
    if (productForms) window.dispatchEvent(
      new CustomEvent('variant:change', {
        detail: {
          variant: this.currentVariant,
        },
      })
    )
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability')
    if (!pickUpAvailability) return

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id)
    } else {
      pickUpAvailability.removeAttribute('available')
      pickUpAvailability.innerHTML = ''
    }
  }

  updateStickySizeInfo() {
    const sizeInfoSpan = document.querySelector('.js-size-variant')
    const wrapper = sizeInfoSpan?.closest('.js-size-variant-wrapper')

    if (sizeInfoSpan && this.currentVariant) {
      sizeInfoSpan.textContent = this.currentVariant.title
      if (wrapper) wrapper.removeAttribute('hidden')
    }
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id)
        const source = html.getElementById(id)
        const stickyBar = document.querySelector('hh-product-sticky-bar')

        if (source && destination) destination.innerHTML = source.innerHTML

        document
          .getElementById(`price-${this.dataset.section}`)
          ?.classList.remove('visibility-hidden')
        if (stickyBar) {
          stickyBar.querySelector('[data-price]').innerHTML = source.innerHTML
        }
      })
    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings.getNotified
    )
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    // Use requestAnimationFrame to ensure DOM is ready
    // This fixes timing issues when the variant picker loads before the modal is fully rendered
    requestAnimationFrame(() => {
      // Find the form in the same context as the variant picker
      // Look for the form within the closest product form wrapper to handle cases
      // where multiple forms with the same ID exist (e.g., card form + quick-view modal)
      const productFormWrapper = this.closest('.js-product-form-wrapper')
      const selectedForm = productFormWrapper?.querySelector(`#product-form-${this.dataset.section}`) || 
                          document.getElementById(`product-form-${this.dataset.section}`)
      const addButton = selectedForm?.querySelector('[name="add"]')

      const stickyAtc = document
        .querySelector(`.product__info-container[data-section=${this.dataset.section}]`)
        ?.querySelector('.js-sticky-atc')

      if (disable) {
        if (addButton) {
          addButton.setAttribute('disabled', true)
          addButton.classList.add('hidden')
          if (text) addButton.textContent = text
        }
        if (stickyAtc) {
          stickyAtc.setAttribute('data-notify', 'true')
          if (text) stickyAtc.textContent = text
        }
      } else {
        if (addButton) {
          addButton.removeAttribute('disabled')
          addButton.classList.remove('hidden')
          addButton.textContent = window.variantStrings.addToCart
        }
        if (stickyAtc) {
          stickyAtc.setAttribute('data-notify', 'false')
          stickyAtc.textContent = window.variantStrings.addToCart
        }
      }

      if (!modifyClass) return
    })
  }

  setUnavailable() {
    // Use requestAnimationFrame to ensure DOM is ready
    requestAnimationFrame(() => {
      // Find the form in the same context as the variant picker
      const productFormWrapper = this.closest('.js-product-form-wrapper')
      const selectedForm = productFormWrapper?.querySelector(`#product-form-${this.dataset.section}`) || 
                          document.getElementById(`product-form-${this.dataset.section}`)
      const addButton = selectedForm?.querySelector('[name="add"]')
      if (!addButton) return
      addButton.textContent = window.variantStrings.unavailable
      document
        .getElementById(`price-${this.dataset.section}`)
        ?.classList.add('visibility-hidden')
    })
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent)
    return this.variantData
  }
}

customElements.define('hh-variant-picker', HHVariantPicker)
